// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"15":"3a009bca","143":"2985fdd4","878":"ff6b3f5c"}[chunkId] + ".js";
};